export default "__VITE_ASSET__1038c953__"